'use strict';

angular.module('internal.applications')
    .controller('InternalApplicationProcessChangeModal', ['$scope', '$uibModalInstance', 'status', 'note', function ($scope, $uibModalInstance, status, note) {
        $scope.modalContent = {};
        $scope.modalContent.status = status;
        $scope.modalContent.note = note;

        $scope.yes = function () {
            $uibModalInstance.close($scope.modalContent);
        }

        $scope.no = function () {
            $uibModalInstance.close(null);
        }
    }])
;